import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core'
import { ValidatorFn } from '@angular/forms'
import { environment } from '../../../../../environments/environment'

import { HTMLInputEvent } from '../../../../shared/interfaces/html-input-event.interface'
import { FlashMessageService } from '../../../../shared/services/flash-message.service'
import { MediaService } from '../../../../shared/services/media.service'

@Component({
  selector: 'app-image-input',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss']
})
export class ImageInputComponent {
  @Input() label: string
  @Input() placeholder: string
  @Input() helpText: string
  @Input() resourceName: 'tools' | 'tool-use-cases'
  @Input() validators: ValidatorFn[] = []

  @Output() valueChanged: EventEmitter<string> = new EventEmitter()

  @ViewChild('imageInput', { static: false }) imageInputEl: ElementRef

  imagePath: string

  fileContent: any
  loading: boolean

  constructor(
    private flashMessageService: FlashMessageService,
    private mediaService: MediaService
  ) {}

  // Upload image and update value.
  // ! Only works with toolUseCases.
  imageInputEvent(imageInput: HTMLInputEvent) {
    this.loading = true
    this.fileContent = this.imageInputEl.nativeElement.files.item(0)
    this.mediaService.upload(this.resourceName, this.fileContent).then(
      (res: { path: string }) => {
        this.loading = false
        this.imagePath = `${environment.apiCatalogStoragePath}${res.path}-thumbnail.jpg`
        this.valueChanged.emit(res.path)
      },

      () => {
        this.loading = false
        this.flashMessageService.error(
          `An error occurred while uploading the image`
        )
      }
    )
  }

  removeFile() {
    delete this.imagePath
    this.valueChanged.emit(null)
  }
}
